/**
 * Make ajax request.
 *
 * @param url
 * @param data
 * @param callback
 * @param method
 * @param isJSON
 * @param asString
 */
export function request(callback = {}, data = {}, url = '', method = 'POST', isJSON = true, asString = false) {
    if (typeof callback !== 'function') {
        return;
    }
    if ((!url || url === '') && typeof ajaxurl === 'undefined') {
        url = '/wp-admin/admin-ajax.php';
    }
    if (!url && typeof ajaxurl === 'string') {
        url = ajaxurl;
    }
    let request = new XMLHttpRequest();
    request.open(method, url, true);
    if (asString) {
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    }
    request.onload = function () {
        if (!isJSON) {
            callback(this.response);
            return;
        }
        if (request.readyState === XMLHttpRequest.DONE && this.status === 200) {
            callback(JSON.parse(this.response));
        } else {
            callback({'success': false});
        }
    };
    if (asString) {
        data = new URLSearchParams(data).toString();
    }
    request.send(data);
}
